export class RestoreMicrosoft365UserMailRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreScope",
            "baseName": "restoreScope",
            "type": "Microsoft365UserMailRestoreScope",
            "format": ""
        },
        {
            "name": "selectedItems",
            "baseName": "selectedItems",
            "type": "Microsoft365UserMailSelectedItemsOptions",
            "format": ""
        },
        {
            "name": "targetSaasEntityId",
            "baseName": "targetSaasEntityId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreMicrosoft365UserMailRequest.attributeTypeMap;
    }
    constructor() {
    }
}
